import { render, staticRenderFns } from "./RitsumeiView.vue?vue&type=template&id=769851fc&scoped=true&"
import script from "./RitsumeiView.vue?vue&type=script&lang=js&"
export * from "./RitsumeiView.vue?vue&type=script&lang=js&"
import style0 from "./RitsumeiView.vue?vue&type=style&index=0&id=769851fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769851fc",
  null
  
)

export default component.exports